export default {
  search: 'Buscar',
  userAccessFor: 'Acceso de usuario para:',
  save: 'Guardar',
  warning: 'Advertencia',
  cannotBeUndone: 'Esta acción no se puede deshacer. ¿Está seguro?',
  abort: 'Cancelar',
  confirm: 'Confirmar',
  processing: 'Procesando...',
  email: 'Correo electrónico',
  name: 'Nombre',
  users: 'Usuarios'
}
